var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TimeAgo from "../../Timeago";
var Automated = function (_a) {
    var _b;
    var execution = _a.execution;
    return (_jsxs("div", __assign({ className: "chat__messages-group" }, { children: [_jsx("ul", __assign({ className: "chat__messages-list" }, { children: _jsx("li", __assign({ className: "chat__messages-list-item" }, { children: _jsx("div", __assign({ className: "chat__messages-bubble chat__message-type-TEXT" }, { children: _jsx("span", __assign({ className: "actual" }, { children: (_b = execution.node.data.formData) === null || _b === void 0 ? void 0 : _b.message })) })) })) })), _jsxs("div", __assign({ className: "chat__all-messages-item-header", style: { paddingTop: '4px' } }, { children: [_jsx("p", __assign({ className: "chat-messages-username", style: { fontSize: '12px' } }, { children: " Automated" })), _jsxs("p", __assign({ className: "chat__all-messages-item-header-timegao", style: { fontSize: '12px' } }, { children: ["\u2022", " ", _jsx(TimeAgo, { date: execution === null || execution === void 0 ? void 0 : execution.created_time_in_millis })] }))] }))] })));
};
export default Automated;
